import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          {/* Columna 1: Logo y Misión */}
          <Col md={4} className="mb-4">
            <img src="/Logo.svg" alt="SerBusiness Logo" className="footer-logo mb-3" />
            <p>
              Ayudando a negocios a prosperar en el mundo digital a través de soluciones innovadoras y un servicio con propósito.
            </p>
          </Col>

          {/* Columna 2: Enlaces Rápidos */}
          <Col md={{ span: 2, offset: 1 }} className="mb-4">
            <h5>Enlaces</h5>
            <ul className="footer-links">
              <li><a href="#services">Servicios</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#contact">Contacto</a></li>
            </ul>
          </Col>

          {/* Columna 3: Contacto y Redes Sociales */}
          <Col md={5} className="mb-4">
            <h5>Contacto</h5>
            <ul className="footer-links">
              <li>Tel: +57 314 458 2454</li>
              <li>Email: serandbusiness@gmail.com</li>
            </ul>
            <div className="social-icons mt-3">
              <a href="#facebook" aria-label="Facebook"><FaFacebook /></a>
              <a href="#instagram" aria-label="Instagram"><FaInstagram /></a>
              <a href="#linkedin" aria-label="LinkedIn"><FaLinkedin /></a>
            </div>
          </Col>
        </Row>

        {/* Nota Legal */}
        <Row>
          <Col className="text-center footer-legal">
            <p>&copy; 2025 SerBusiness SAS – Servir es el propósito.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
